// extracted by mini-css-extract-plugin
export default {"content-column":"Misc_content-column__dk2ly","invalid":"Misc_invalid__kAf+g"};